// 	export default  [
// 	{ icon:'business', title: "办公业务",value: "办公业务",icon:'../../static/logo/tabarIndexLogo/business.png'},
// 	{ icon:'other', title: "其他",value: "其他",icon:'../../static/logo/tabarIndexLogo/other.png'},
// 	{ icon:'LeadershipView', title: "领导视图",value: "领导视图",icon:'../../static/logo/tabarIndexLogo/LeadershipView.png'}
// // ]

export default [
	{ label:'业务日期：',xs:24,sm:24,md:12,lg:8,xl:8,type:'date',modelValue:'busDate',disabled:true},
	{ label:'发票日期：',xs:24,sm:12,md:12,lg:8,xl:8,type:'date',modelValue:'invoDate'},
	{ label:'发票编号：',xs:24,sm:12,md:8,lg:8,xl:8,type:'input',modelValue:'purcInvoCodg'},
	// { label:'终端序号：',xs:24,sm:16,md:12,lg:6,xl:6,type:'input',modelValue:'terminalId',prop:'terminalId',disabled:true},
	
	// { label:'作废人：',xs:24,sm:24,md:12,lg:6,xl:6,type:'input',modelValue:'nullifyB',disabled:true},
	// { label:'作废状态：',xs:24,sm:24,md:12,lg:6,xl:6,type:'select',modelValue:'checkAcceptState',op:'AcceptStateOption',disabled:true},
	// { label:'作废时间：',xs:24,sm:24,md:12,lg:6,xl:6,type:'date',modelValue:'nullifyTime',disabled:true},
	// { label:'诊所ID：',xs:24,sm:24,md:12,lg:6,xl:6,type:'select',modelValue:'clinicId',disabled:true,op:'clinicOption',},
	
	{ label:'库房名称：',xs:24,sm:24,md:12,lg:6,xl:6,type:'select',modelValue:'phayId',op:'selectOption'},
	// { label:'当前制单人：',xs:24,sm:24,md:12,lg:6,xl:6,type:'input',modelValue:'creater',disabled:true},
	// { label:'制单人Id：',xs:24,sm:24,md:12,lg:6,xl:6,type:'input',modelValue:'createId',disabled:true},
	// { label:'制单时间：',xs:24,sm:24,md:12,lg:6,xl:6,type:'date',modelValue:'createTime',disabled:true},
	
	{ label:'供货单位：',xs:24,sm:8,md:8,lg:6,xl:6,type:'input',modelValue:'supplierName',op:'gysOption'},
	{ label:'供货单号：',xs:12,sm:16,md:8,lg:6,xl:6,type:'input',modelValue:'supplyCode'},
	{ label:'入库方式：',xs:12,sm:12,md:8,lg:6,xl:6,type:'select',modelValue:'putinTypeId',op:'rkWaysOptions'},
	// { label:'提交状态：',xs:12,sm:12,md:8,lg:6,xl:6,type:'select',modelValue:'state',op:'stateOptions'},
	
	{ label:'备注：',xs:24,sm:24,md:24,lg:24,xl:24,type:'textarea',modelValue:'remark'},
]

